module.exports = __webpack_public_path__ + "img/s1-0-s.ac091b1d.svg";